import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from '@mui/material'
import md5 from 'md5'
import {useState} from 'react'
import HomeMadeSnackbar from '../../components/snackbars/HomeMadeSnackbar'
import httpReq from '../../services/httpReq'
import {Controller, useForm} from "react-hook-form";
import {msg} from "@lingui/macro";
import {CustomIconButton} from "../../components/buttons/CustomIconButton";
import {useLingui} from "@lingui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FullPageLoader from "../../components/loaders/FullPageLoader";
import useMobile from "../../hooks/useMobile";
import {useNavigate} from "react-router-dom";

const ChangePasswordPage = () => {
    const isMobile = useMobile();
    const navigate = useNavigate();

    const {control, formState, handleSubmit, getValues} = useForm({mode: 'onChange'})

    const [oldPasswordIsVisible, setOldPasswordIsVisible] = useState('')
    const [newPasswordIsVisible, setNewPasswordIsVisible] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const {_} = useLingui()
    const [isOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [snackbarValues, setSnackbarValues] = useState({
        btnColor: '',
        color: '',
        closeAction: true,
        message: ''
    })

    const handleChangePassword = async () => {
        const values = getValues()
        setIsLoading(true)

        const data = {
            username: values.username,
            oldPassword: md5(values.oldPassword).toUpperCase(),
            newPassword: md5(values.newPassword).toUpperCase()
        }
        const res = await httpReq('Auth/ChangePassword', 'POST', data, true)
        if (!res.responseAnyError) {
            navigate('')
            setIsLoading(false)
            setIsOpenSnackbar(true)
            setSnackbarValues({
                btnColor: 'white',
                closeAction: true,
                message: `Password changed successfully!`,
                color: 'green'
            })
        } else {
            setIsOpenSnackbar(true)
            setSnackbarValues({
                btnColor: 'white',
                closeAction: true,
                message: `Error.`,
                color: 'red'
            })
            setIsLoading(false)
        }
    }

    const handleMouseDownOldPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseDownNewPassword = (event) => {
        event.preventDefault();
    };

    const handleBack = () => {
        navigate('../profile')
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: `calc(100%)`,
                p: isMobile ? 1 : 4
            }}>
                <Card sx={{
                    width: isMobile ? '100%' : 600,
                    p: 3,
                    borderRadius: 4,
                    boxShadow: 10,
                    backgroundColor: 'white',
                    animation: 'fadeInUp 0.6s ease-out'
                }}>
                    <CardHeader
                        sx={{mb: 2, p: 0}}
                        title={
                            <Box sx={{position: 'relative', height: 56, display: 'flex', alignItems: 'center'}}>
                                {/* Back button */}
                                <IconButton onClick={() => handleBack()}
                                            sx={{position: 'absolute', left: 0, cursor: 'pointer', zIndex: 10}}>
                                    <ArrowBackIcon/>
                                </IconButton>

                                {/* Centered title */}
                                <Typography
                                    variant="h5"
                                    fontWeight="bold"
                                    textAlign="center"
                                    sx={{
                                        width: '100%',
                                        position: 'absolute',
                                        left: 0,
                                        right: 0,
                                        textAlign: 'center',
                                    }}
                                >
                                    Change password
                                </Typography>
                            </Box>
                        }
                    />

                    <CardContent>
                        <Grid container sx={{display: 'flex'}} spacing={2}>
                            <Grid item xs={12}
                                  sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
                                <Controller
                                    name='username'
                                    control={control}
                                    defaultValue=""
                                    fullWidth
                                    render={({field, fieldState}) => (
                                        <TextField
                                            sx={{display: 'flex', flex: 2}}
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            label={_(msg`Username`)}
                                            autoComplete='username'
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}
                                  sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
                                <Controller
                                    name='oldPassword'
                                    fullWidth
                                    control={control}
                                    defaultValue=""
                                    render={({field, fieldState}) => (
                                        <TextField
                                            sx={{display: 'flex', flex: 2}}
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <CustomIconButton
                                                            color={'primary'}
                                                            variant={'filled'}
                                                            onClick={() => setOldPasswordIsVisible(!oldPasswordIsVisible)}
                                                            size={'small'}
                                                            disabled={false}
                                                            icon={oldPasswordIsVisible ? 'view' : 'hide'}
                                                            iconSize={'small'}
                                                            onMouseDown={handleMouseDownOldPassword}
                                                        />
                                                    </InputAdornment>
                                                )
                                            }}
                                            type={oldPasswordIsVisible ? 'text' : 'password'}
                                            label={_(msg`Old Password`)}
                                            autoComplete='oldPassword'
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}
                                  sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
                                <Controller
                                    name='newPassword'
                                    fullWidth
                                    control={control}
                                    defaultValue=""
                                    render={({field, fieldState}) => (
                                        <TextField
                                            sx={{display: 'flex', flex: 2}}
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <CustomIconButton
                                                            color={'primary'}
                                                            variant={'filled'}
                                                            onClick={() => setNewPasswordIsVisible(!newPasswordIsVisible)}
                                                            size={'small'}
                                                            disabled={false}
                                                            icon={newPasswordIsVisible ? 'view' : 'hide'}
                                                            iconSize={'small'}
                                                            onMouseDown={handleMouseDownNewPassword}
                                                        />
                                                    </InputAdornment>
                                                )
                                            }}
                                            type={newPasswordIsVisible ? 'text' : 'password'}
                                            label={_(msg`New Password`)}
                                            autoComplete='newPassword'
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid sx={{display: 'flex', justifyContent: 'center'}} item xs={12}>
                                <Button onClick={() => {
                                    handleChangePassword()
                                }} sx={{width: '40%'}} variant="contained">Change password</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
            {isOpenSnackbar &&
                <HomeMadeSnackbar
                    setIsOpen={setIsOpenSnackbar}
                    btnColor={snackbarValues.btnColor}
                    closeAction={snackbarValues.closeAction}
                    color={snackbarValues.color}
                    message={snackbarValues.message}
                />
            }
            {isLoading && <FullPageLoader/>}
        </>
    )
}
export default ChangePasswordPage
